<div class="sh-page-section--extrawide">
    <ng-container *ngIf="disclaimerContent$ | async as disclaimerContent; else disclaimerError">
        <sh-page-header [title]="disclaimerContent.title"></sh-page-header>

        <sh-detail-layout>
            <ng-template #main>
                <div class="sh-sticky-header">
                    <sh-scrollspy-nav [items]="scrollspyNavItems$ | async"></sh-scrollspy-nav>
                </div>
                <ng-container *ngFor="let section of disclaimerContent.sections">
                    <h4 *ngIf="section.sectionTitle" [id]="section.sectionTitle">
                        <sh-html-parser [message]="section.sectionTitle"></sh-html-parser>
                    </h4>
                    <p *ngFor="let paragraph of section.paragraphs" class="sh-notification__msg">
                        <span [innerHtml]="paragraph"></span>
                    </p>
                </ng-container>
            </ng-template>
        </sh-detail-layout>
    </ng-container>
</div>

<ng-template #disclaimerError>
    <sh-notification [type]="notificationType.Error" [message]="'errors.translation-not-found' | translate" [icon]="'delete'"></sh-notification>
</ng-template>
